// https://community.apollographql.com/t/relaystylepagination-doesnt-check-if-edges-were-actually-queried/8731/4
// https://github.com/apollographql/apollo-client/issues/6792
import { FieldPolicy, Reference } from "@apollo/client";
import { RelayFieldPolicy } from "@apollo/client/utilities/policies/pagination";

export function nexusStylePagination<TNode extends Reference = Reference>(
  keyArgs: FieldPolicy["keyArgs"] = false,
): RelayFieldPolicy<TNode> {
  const cursorArgs = ["first", "after", "last", "before"];
  if (Array.isArray(keyArgs)) {
    return {
      keyArgs: [...keyArgs, ...cursorArgs],
    };
  }
  return {
    keyArgs,
  };
}
